import axios from 'axios';
import { oktaAuth } from '../providers/OktaProvider';

export const request = axios.create();
export const thirdPartyRequest = axios.create();

// pos interceptor request
request.interceptors.request.use(
  (req) => {
    const oktaStorage = window.localStorage.getItem('okta-token-storage');

    // let UTCOffset = new Date().getTimezoneOffset();
    // UTCOffset = -UTCOffset;
    //   oktaAuth.tokenManager.getTokens().then((token) => token.accessToken);
    //   oktaAuth.tokenManager.getAccessToken()

    // const accessToken = oktaStorage ? JSON.parse(oktaStorage)?.accessToken?.accessToken : oktaAuth.tokenManager.getAccessToken();
    const accessToken = oktaAuth.getAccessToken();
    // console.log('accessT', accessToken);

    if (accessToken) {
      req.headers!.authorization = `Bearer ${accessToken}`;
    }
    let serviceUrl = '';
    if (process.env.NODE_ENV === 'development') {
      const service = req.url?.split('/')[0];
      switch (service) {
        case 'inventory':
          serviceUrl = process.env.REACT_APP_INVENTORY_SERVICE_URL!;
          break;
        case 'core':
          serviceUrl = process.env.REACT_APP_CORE_SERVICE_URL!;
          break;
        default:
          serviceUrl = process.env.REACT_APP_API!;
      }
    } else {
      serviceUrl = process.env.REACT_APP_API!;
    }
    req.baseURL = serviceUrl;
    // req.headers.common["language"] = "en";
    // req.headers.common["utcoffset"] = UTCOffset;
    return req;
  },
  (error) => {
    return Promise.reject(error);
  }
);

//  axios interceptor response
request.interceptors.response.use(
  (response: any) => response,
  (error: any) => {
    // Cancelled, timed out and network errors carry no response.
    switch (error?.response?.status) {
      case 401:
        localStorage.clear();
        window.location.reload();
        break;
      case 400:
        // toast.error(error.response.data.message);
        break;
      default:
        break;
      // toast.error('Something really went wrong, please try again');
    }
    return Promise.reject(error);
  }
);

export default request;
